import { Roles } from '../auth/roles';

const pathPrefix = '';

export const Routes = {
  Home: `${pathPrefix}/home`,
  Overview: `${pathPrefix}/overview`,
  KWS: `${pathPrefix}/kws`,
  KWH: `${pathPrefix}/kwh`,
  DWS: `${pathPrefix}/dws`,
  Sustainability: `${pathPrefix}/sustainability`,
  AdminUsers: `${pathPrefix}/adminUsers`,
  CreateTenant: `${pathPrefix}/createTenant`,
};

export const NavbarMainRoutes = [
  {
    url: Routes.Home,
    name: 'home',
  },
  {
    url: Routes.Overview,
    name: 'overview',
  },
  {
    url: Routes.KWH,
    name: 'kwh',
  },
  {
    url: Routes.KWS,
    name: 'kws',
  },
  {
    url: Routes.DWS,
    name: 'dws',
  },
  {
    url: Routes.Sustainability,
    name: 'sustainability',
  },
  {
    url: Routes.CreateTenant,
    name: 'createTenant',
    role: Roles.FinoSupport,
  },
];
